import { Layout } from 'Components/Layout/Layout'
import { DashboardContainer } from 'Containers/Dashboard/DashboardContainer'
import React from 'react'

export const Dashboard = () => {
  return (
    <Layout>
         <DashboardContainer/>
    </Layout>
   
  )
}

